<template>
  <div class="tab-content">
    <div class="title-wrap">
      <h2 class="title">
        {{ cnt.title }}
        <span v-if="cnt.subTitle !== '' && cnt.subTitle !== null"
          >【{{ cnt.subTitle }}代下载】</span
        >
      </h2>
      <!-- <div class="btnfr"> -->
      <!-- <img
          src="@/assets/images/activity/charge11.gif"
          class="btnimg"
          @click="gotoRe()"
        /> -->
      <!-- <el-button class="btnf" @click="gotoRe()">充值优惠</el-button> -->
      <!-- </div> -->
      <div class="fr" v-if="cnt.titleState == 'success'">
        <el-button type="success" icon="el-icon-check" circle></el-button>正常
      </div>
      <div class="fr" v-if="cnt.titleState == 'error'">
        <el-button type="danger" icon="el-icon-close" circle></el-button>异常
      </div>
    </div>
    <el-input
      type="textarea"
      v-model="cnt.label"
      @input="descInput"
      :placeholder="'请将' + cnt.title + placeholder"
      class="isTextarea"
    ></el-input>
    <p class="error">{{ errorMsg }}</p>
    <el-button
      class="btn-border"
      type="primary"
      @mousedown.native="search"
      plain
      icon="el-icon-search"
      :disabled="isSearching"
      >搜索</el-button
    >
  </div>
</template>

<script>
import { message } from "@/utils/resetMessage";
export default {
  props: {
    // 带有默认值的对象
    tabContent: {
      type: Object,
      default() {
        return {
          title: "",
          subTitle: "",
          label: "",
        };
      },
    },
    intimes: {
      type: Number,
    },
    isSearching: {
      type: Boolean,
    },
  },
  data() {
    return {
      placeholder:
        "图片ID编号粘贴到本框提交，一个ID编号一行，多个ID号请回车另起一行输入，没有被加载说明图片不存在或无法下载…",
      errorMsg: "",
      form: {
        imageId: "",
        webType: "",
      },
    };
  },
  computed: {
    cnt() {
      return this.tabContent;
    },
  },
  mounted() {},
  methods: {
    search() {
      if (this.intimes <= 0) {
        message.error({
          message: "下载次数为0，不能搜索",
          duration: 4000,
          offset: 80,
        });
        return;
      }
      if (this.cnt.label !== "" && this.cnt.label !== null) {
        if (this.cnt.label.split(/\n/).length > 100) {
          message.error({
            message: "ID行数限制100行",
            duration: 4000,
            offset: 80,
          });
          return;
        }
        this.errorMsg = "";
        var recArray = this.cnt.label.split("\n");
        //搜索过滤回车
        var recNewArray = [];
        for (var i = 0; i < recArray.length; i++) {
          if (recArray[i].length > 3) {
            if (
              recArray[i].indexOf("pptuku") == -1 &&
              recArray[i].indexOf("taogetu") == -1
            ) {
              // hi 开头 = hellorf 素材，前缀必须原样传给后端：
              // 实测 hellorf 侧 "hi2256220513" 与 "2256220513" 是两条不同的素材，
              // 前缀是 ID 的组成部分，在这里被削成纯数字会搜到另一张图、或把在架的图搜成"已下架"。
              // 原来只认 hi22 一个号段，其余 hi 号会掉进下面的纯数字分支。
              var recTrim = recArray[i].replace(/ /g, "");
              var hiInUrl = recTrim.split("?")[0].match(/\/hi(\d+)/i);
              if (/^hi\d+$/i.test(recTrim)) {
                if (recNewArray.indexOf(recTrim) < 0) {
                  recNewArray.push(recTrim);
                }
              } else if (hiInUrl) {
                //链接形式：只取 /hi 后面的数字，避免把 .html 之类的尾巴也带进 ID
                var rec = "hi" + hiInUrl[1];
                if (recNewArray.indexOf(rec) < 0) {
                  recNewArray.push(rec);
                }
              } else {
                var pattern = /[0-9]\d{4,12}/g;
                var matchResult = recArray[i].replace(/ /g, "").match(pattern);
                try {
                  if (matchResult.length > 0) {
                    var rec = "";
                    matchResult.forEach((item) => {
                      rec += item;
                    });
                    if (rec != null && rec != "" && typeof rec != "undefined") {
                      if (recNewArray.indexOf(rec) < 0) {
                        recNewArray.push(rec);
                      }
                    }
                  }
                } catch (e) {
                  this.errorMsg = "存在ID无效";
                }
              }
            }
          }
        }
        if (recNewArray.length > 0) {
          this.$emit("search", recNewArray);
        } else {
          this.errorMsg = "ID不能为空";
        }
      } else {
        this.errorMsg = "ID不能为空";
      }
    },
    descInput() {
      this.txtVal = this.cnt.label;
      if (this.txtVal.split(/\n/).length > 100) {
        message.error({
          message: "ID行数限制100个",
          duration: 4000,
          offset: 80,
        });
        return;
      }
    },
    gotoRe() {
      // this.$router.push({ path: "/pay" });
      // this.$store.commit("asideMenuId", 3);
      this.$router.push({ path: "/registered" });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tab-content {
  .title-wrap {
    margin-bottom: 15px;
    display: flex;
    .title {
      display: inline-block;
      font-size: 32px;
      color: #000;
      font-weight: normal;
    }
    .btnfr {
      margin-left: 15px;
      font-size: 14px;
    }
    .fr {
      margin-left: auto;
      color: #44d995;
      margin-right: 30px;
      .iconfont {
        font-size: 20px;
      }
    }
    .fr1 {
      margin-left: auto;
      color: #ea0615;
      margin-right: 30px;
      .iconfont {
        font-size: 20px;
      }
    }
    .el-button.is-circle {
      margin-right: 10px;
      padding: 0;
      width: 16px;
      height: 16px;
      line-height: 16px;
      border-radius: 50%;
    }
  }
  .btn-border.el-button {
    margin-bottom: 15px;
    padding: 15px 20px;
    width: 100%;
    font-size: 16px;
    color: #0773fc;
    border-color: #0773fc;
    outline: none;
    i {
      color: #0773fc;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #0773fc;
    border-color: #0773fc;
    color: #ffffff;
  }
  .error {
    margin-bottom: 10px;
    color: #f56c6c;
  }
  .btnimg {
    max-width: 100px;
    height: auto;
    width: 100%;
    text-align: center;
    cursor: pointer;
  }

  .btnf {
    color: #6b3d1e;
    font-weight: 700;
    background-image: linear-gradient(90deg, #ffe9d2, #ffbf8f);
    border-color: #fff;
    font-size: 14px;
    padding: 12px 15px;
    &:hover {
      background-image: linear-gradient(90deg, #f0bb93 100%, #f0bb93 100%);
      border-color: #fff;
    }
    &:active {
      background-image: linear-gradient(90deg, #ffe9d2, #ffbf8f);
      border-color: #fff;
    }
  }
}
</style>
